import { DataGridLayout, List } from 'framework/list';
import { useContextHelper } from 'framework/utils';
import { FieldProps, TextField, HtmlField, EnumField } from 'framework/ui/field';
import { PositionEnumField, SIMPLE_QUALIFICATION } from 'domain/shared/presale';
import { PROJECT_MEMBERSHIP_ROLES } from 'domain/shared/core/constants';
import { FormFieldsData } from 'framework/form';
import { EmployeeCompetencyLevelField, EmployeeTechnologyField } from 'domain/shared/employee';

const RequiredResourcesListField = ({ label, source = '', ...props }: FieldProps<string[]>) => {
  const { getFromAnyContext } = useContextHelper();
  const resources = getFromAnyContext(source);

  const getRequiredResourcesData = async () => {
    return Promise.resolve({ result: resources });
  };
  const hasQualification = resources?.some((resource: FormFieldsData) => resource?.qualification);

  const listResources = (
    <div>
      <div>
        <HtmlField source="" value=" " label={label} />
      </div>
      <div>
        <List getDataMethod={getRequiredResourcesData}>
          <DataGridLayout isSmallTable sxTableWrapper={{ '& table': { minWidth: '500px' } }}>
            <PositionEnumField source="positionId" label="Position" width={200} />
            <EmployeeTechnologyField source="technologyId" label="Technology" width={150} />
            <EnumField options={PROJECT_MEMBERSHIP_ROLES} label={'Role'} source={'teamRole'} width={200} />
            <EmployeeCompetencyLevelField label={'Min Level'} source={'minLevel'} width={50} />
            <EmployeeCompetencyLevelField label={'Max Level'} source={'maxLevel'} width={50} />
            <TextField source="requiredFte" label="FTE, %" width={100} />
            <EnumField
              options={SIMPLE_QUALIFICATION}
              source="qualification"
              disabled
              label={hasQualification ? 'Qualification' : ''}
              width={hasQualification ? 50 : 1}
              isVisible={() => hasQualification}
            />
            <TextField source={'noteText'} label="Note" width={300} />
          </DataGridLayout>
        </List>
      </div>
    </div>
  );

  return resources.length > 0 ? listResources : <></>;
};

export default RequiredResourcesListField;
